import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Agac from "./views/AgacPage"
import MetinPage from "./views/MetinPage"
import DalPage from "./views/DalPage"
import ParatonerPage from "./views/ParatonerPage"
import YaprakPage from "./views/YaprakPage"
import MadalyonPage from "./views/MadalyonPage"
import KazimaPage from "./views/KazimaPage"
import YaziPage from "./views/YaziPage"
import YaprakYakinPage from "./views/YaprakYakinPage"
import KunyePage from "./views/KunyePage"

Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home
		},
		{
			path: '/about',
			name: 'about',
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
		},
		{
			path: '/acacia',
			name: 'agac',
			component: Agac
		},
		{
			path: '/engrave-locket',
			name: 'metin',
			component: MetinPage
		},
		{
			path: '/engrave-locket',
			name: 'metin2',
			component: MetinPage
		},
		{
			path: '/muzzle',
			name: 'dal',
			component: DalPage
		},
		{
			path: '/empty-armor',
			name: 'paratoner',
			component: ParatonerPage,
		},
		{
			path: '/i-drank-all-the-white-i-cant-feel-my-bones',
			name: 'madalyon',
			component: MadalyonPage
		},
		{
			path: '/death-mans-wreath',
			name: 'yaprak',
			component: YaprakPage
		},
		{
			path: '/death-mans-wreath-close',
			name: 'yaprak-yakin',
			component: YaprakYakinPage
		},
		{
			path: '/engrave',
			name: 'kazima',
			component: KazimaPage
		},
		{
			path: '/an-acrid-slit-coming-down-from-the-sky',
			name: 'yazi',
			component: YaziPage
		},
		{
			path: '/tags',
			name: 'kunye',
			component: KunyePage
		},


	]
})
